module.exports = __webpack_public_path__ + "img/lzzz1.769dcd42.png";